import React, { useState } from "react";
import {
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
} from "reactstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import PropTypes from "prop-types";
import Select from "react-select";
import CustomSelect from "../../../../components/Common/CustomSelect";

const WarehouseCabinetsModal = props => {
  const { isOpen, toggle } = props;

  // const sources = (props.adPlatforms?.results || props.adPlatforms).map(
  const capitalize = s => {
    return s[0].toUpperCase() + s.slice(1);
  };

  const sources = ["asa", "adwords", "facebook", "snapchat", "tiktok", "unity"].map(
    item => {
      return {
        label: capitalize(item),
        value: item,
      };
    }
  );

  const [selectedPlatform, setSelectedPlatform] = useState();
  const [isSubmitForm, setIsSubmitForm] = useState(false);

  React.useEffect(() => {
    return () => {
      setSelectedPlatform();
    };
  }, []);

  const handleValidOrderSubmit = (e, errors, params) => {
    setIsSubmitForm(true);
    if (errors?.length === 0) {
      props.postWHTrigger({
        platform: params.ad_platform?.value,
      });
      toggle();
    }
  };

  const onSetSelectedPlatform = v => {
    if (selectedPlatform?.label != v.label) {
      setSelectedPlatform(v);
    }
  };

  return (
    <Modal isOpen={isOpen} autoFocus centered toggle={toggle}>
      <div className="modal-header">
        <h4 className="modal-title mt-0" id="myModalLabel">
          Load platforms cabinets
        </h4>
        <button
          type="button"
          onClick={toggle}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <AvForm className="needs-validation" onSubmit={handleValidOrderSubmit}>
        <ModalBody>
          <Row form>
            <Col className="col-12">
              <div className="mb-3">
                <Label>Select platform</Label>
                <CustomSelect
                  name="ad_platform"
                  defaultValue={selectedPlatform}
                  options={sources}
                  placeholder={"Select a platform..."}
                  onChange={onSetSelectedPlatform}
                  classNamePrefix="select2-selection"
                  errorMessage="Platform is required"
                  isFormSubmit={isSubmitForm}
                  required
                />
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <button
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="btn btn-primary save-user"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-success save-user ms-2"
                >
                  Start
                </button>
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

WarehouseCabinetsModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  adPlatforms: PropTypes.any,
  permissions: PropTypes.any,
  postWHTrigger: PropTypes.func,
};

export default WarehouseCabinetsModal;
